export type FieldComponentLoader = () => Promise<any>;

export const LAB_COMPONENTS_REGISTRY: Record<string, FieldComponentLoader> = {
  MpsFrameLazyloadingComponent: () =>
    import('@lab/mps-kit/mps-view/custom/fields/mps-frame-lazyloading.component').then(
      (m) => m.MpsFrameLazyloadingComponent
    ),
};
